module.exports = __webpack_public_path__ + "img/天玑城.ecc8c1d5.jpg";